import { watch } from "vue"

/**
 * Applies a watch to the user details to ensure the contact email matches if one isn't set
 * 
 * @param {Object} form 
 */
export function createFormFieldTicketQuantityWatch(form){
    watch(() => form.fields.value.ticket.quantity, (newQuantity) => {

        let difference = newQuantity - form.fields.value.ticket.people.length

        if(difference > 0){
            form.fields.value.ticket.people = [
                ...form.fields.value.ticket.people,
                //Fill is passed by reference so using map to provide it by value
                ...Array(difference).fill(null).map(() => ({
                    forename    : '',
                    middle_name : '',
                    surname     : '',
                    email       : '',
                    fields      : {}
                }))
            ]
        }

        else if (difference < 0){
            form.fields.value.ticket.people.splice(
                newQuantity,
                form.fields.value.ticket.people.length
            )
        }
    }, { immediate: true })
}